export const CustomersRoutes = {
    customers: (origin: string) => `${origin}/customers`,
};
